import React from "react";
import styled from "styled-components";

function SpinnerLoader({ textToShow = "" }) {
  return (
    <SpinnerBackground>
      <SpinnerLoaderWrapper>
        <SpinnerLoaderImage src="/assets/front/img/loader.gif" />
        {textToShow.length > 0 ? (
          <InformationText>{textToShow}</InformationText>
        ) : null}
      </SpinnerLoaderWrapper>
    </SpinnerBackground>
  );
}

export default SpinnerLoader;

const InformationText = styled.p`
  text-align: center;
  margin: 0;
`;

const SpinnerBackground = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 99999;
`;

const SpinnerLoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 250px;
`;

const SpinnerLoaderImage = styled.img`
  width: 100%;
`;
